import { useEffect, useRef } from 'react'

interface OpenEffectsInput {
  isOpen: boolean
  searchInputRef: React.RefObject<HTMLInputElement>
  buttonRef: React.RefObject<HTMLButtonElement>
  isMobile: boolean
  onOpenChange?: (open: boolean) => void
}

export function useFocusAndScrollSideEffects({ isOpen, searchInputRef, buttonRef, isMobile, onOpenChange }: OpenEffectsInput): void {
  const previousIsOpenRef = useRef<boolean>(false)

  useEffect(() => { onOpenChange?.(isOpen) }, [isOpen, onOpenChange])

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      setTimeout(() => searchInputRef.current?.focus(), 50)
    }
  }, [isOpen, searchInputRef])

  useEffect(() => {
    if (isOpen && isMobile) {
      document.body.style.overflow = 'hidden'
      return () => { document.body.style.overflow = '' }
    }
  }, [isOpen, isMobile])

  useEffect(() => {
    if (previousIsOpenRef.current && !isOpen) {
      if (buttonRef.current) {
        setTimeout(() => { buttonRef.current?.focus() }, 100)
      }
    }
    previousIsOpenRef.current = isOpen
  }, [isOpen, buttonRef])
}
